export type NavigationState = {
    drawerOpen: boolean;
    drawerVariant: 'persistent' | 'temporary' | 'permanent';
};

export const initialNavigationState: NavigationState = {
    drawerOpen: true,
    drawerVariant: 'permanent',
};
